import { render } from "./MainWellnessArea.vue?vue&type=template&id=eabfe4f0&scoped=true"
import script from "./MainWellnessArea.vue?vue&type=script&lang=js"
export * from "./MainWellnessArea.vue?vue&type=script&lang=js"

import "./MainWellnessArea.vue?vue&type=style&index=0&id=eabfe4f0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabfe4f0"]])

export default __exports__